import classNames from 'classnames';
import { AdminEntityInfoModalProps } from '@/modules/admin-dashboard/components/modals/AdminEntityInfoModal.tsx';
import { EntityWithDocumentFullResponse } from '@/modules/entity/types/EntityItemResponse.ts';
import { Avatar } from 'ui';
import { fixNameEnum } from 'ui/utils';

export interface AdminEntityApprovedItemProps extends EntityWithDocumentFullResponse {
  handleOpenEntityInfoModal: (modalProps: Partial<AdminEntityInfoModalProps>) => void;
}

export const AdminEntityApprovedItem = ({
  type,
  entity_id,
  entity_name,
  registers,
  handleOpenEntityInfoModal,
  ...entity
}: AdminEntityApprovedItemProps) => {
  const { avatar_url, first_name, last_name } = entity.user || {};

  return (
    <div
      className="w-full flex flex-col rounded-xl bg-gray-100 border border-gray-200 cursor-pointer"
      onClick={() =>
        handleOpenEntityInfoModal({ ...entity, type, entity_id, entity_name, registers })
      }
    >
      <div className="w-full flex items-center justify-between px-6 py-[14px]">
        <div className="flex items-center space-x-3">
          <Avatar src={avatar_url} firstName={first_name} lastName={last_name} />
          <div className="flex flex-col">
            <p className="capitalize text-[14px] leading-[22px] font-medium">{entity_name}</p>
            <div className="flex items-center text-[12px] leading-[20px] text-gray-500 space-x-2 divide-x-1">
              <p>{fixNameEnum(type)}</p>
              <p>{entity_id}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full flex flex-col rounded-xl bg-white border-t border-gray-200">
        {registers &&
          registers.map(({ name, id: register_id }, index) => (
            <div
              key={'registers_' + register_id}
              className={classNames('w-full flex items-center justify-between px-6 py-[14px]', {
                'border-b border-gray-200': index !== registers.length - 1,
              })}
            >
              <div className="flex items-center space-x-3">
                <Avatar firstName={name} lastName={String(register_id)} />
                <p className="text-[14px] leading-[22px] font-medium">{name}</p>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};
